export function getAppEnv(): string {
  const raw = String(import.meta.env.VITE_APP_ENV || import.meta.env.MODE || 'local')
    .trim()
    .toLowerCase();
  if (!raw) return 'local';
  if (raw === 'development') return 'local';
  return raw;
}

export function isProductionBuild(): boolean {
  return Boolean(import.meta.env.PROD) || String(import.meta.env.MODE || '').trim().toLowerCase() === 'production';
}

export function isLocalAppEnv(): boolean {
  if (isProductionBuild()) {
    return false;
  }
  return getAppEnv() === 'local';
}
